import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "电影分类", to: "/category" },
  { label: "热门专题", to: "/specials" },
  { label: "站内搜索", to: "/search" },
  { label: "关于我们", to: "/about" },
];

const categories = ["动作", "科幻", "剧情", "爱情", "悬疑", "动画"];

export default function Footer() {
  return (
    <footer className="mt-16 w-full bg-primary-950 text-background-100">
      <div className="mx-auto grid w-full grid-cols-1 gap-8 px-4 py-12 md:grid-cols-2 md:px-6 lg:grid-cols-4 lg:py-16">
        <div className="lg:pr-6">
          <div className="mb-4 flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
              <i className="ri-film-line text-lg"></i>
            </span>
            <span className="font-heading text-lg font-bold">555电影</span>
          </div>
          <p className="text-sm leading-relaxed text-background-300">
            专注电影资讯与优质片单推荐，为影迷提供最新动态、深度分类与观影指南，助你轻松找到下一部想看的好电影。
          </p>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-sm font-semibold text-background-50">快速导航</h4>
          <ul className="flex flex-col gap-2">
            {quickLinks.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="text-sm text-background-300 transition-colors hover:text-accent-400"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-sm font-semibold text-background-50">热门类型</h4>
          <ul className="flex flex-wrap gap-2">
            {categories.map((c) => (
              <li key={c}>
                <Link
                  to={`/category?genre=${encodeURIComponent(c)}`}
                  className="inline-block rounded-full bg-primary-900 px-3 py-1 text-xs text-background-200 transition-colors hover:bg-primary-800"
                >
                  {c}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-sm font-semibold text-background-50">联系我们</h4>
          <ul className="flex flex-col gap-3 text-sm text-background-300">
            <li className="flex items-center gap-2">
              <span className="flex h-5 w-5 items-center justify-center text-accent-400">
                <i className="ri-mail-line text-base"></i>
              </span>
              hello@555movie.com
            </li>
            <li className="flex items-center gap-2">
              <span className="flex h-5 w-5 items-center justify-center text-accent-400">
                <i className="ri-phone-line text-base"></i>
              </span>
              400-555-0555
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-0.5 flex h-5 w-5 items-center justify-center text-accent-400">
                <i className="ri-map-pin-line text-base"></i>
              </span>
              北京市朝阳区光影文化产业园 A 座
            </li>
          </ul>
          <div className="mt-4 flex gap-3">
            {["ri-weibo-fill", "ri-wechat-fill", "ri-youtube-fill", "ri-twitter-x-fill"].map(
              (icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-primary-900 text-background-200 transition-colors hover:bg-accent-500 hover:text-primary-950"
                >
                  <i className={`${icon} text-base`}></i>
                </span>
              ),
            )}
          </div>
        </div>
      </div>

      <div className="border-t border-primary-900">
        <div className="mx-auto flex w-full flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-background-400 sm:flex-row md:px-6">
          <p>© 2026 555电影 · 本站所有内容均为示范展示，不含任何播放与下载服务。</p>
          <p>内容仅供影迷资讯与观影参考</p>
        </div>
      </div>
    </footer>
  );
}